import { useEffect, useState } from "react";

import cx from "@hsl/core/utils/cx";

import Notification from "./Notification";
import { type Notice } from "./types";

type Props = {
    notices: Notice[];
    duration?: number;
    className?: string;
    onComplete?: () => void;
};

const NotificationsBooth = ({
    notices,
    duration = 1000,
    className,
    onComplete,
}: Props) => {
    const [displayedIdx, setDisplayedIdx] = useState<number>(0);
    const closeNotice = (idx: number) => {
        setDisplayedIdx(idx + 1);
    };

    useEffect(() => {
        if (notices.length === displayedIdx) {
            onComplete?.();
            return;
        }
        const timeout = setTimeout(() => {
            setDisplayedIdx((current) => current + 1);
        }, duration);
        return () => clearTimeout(timeout);
    }, [duration, notices.length, displayedIdx, onComplete]);

    return (
        <div
            aria-live="assertive"
            className={cx(
                "pointer-events-none fixed inset-0 z-[99999] flex items-end px-4 py-6 sm:items-start sm:p-6",
                className,
            )}
        >
            <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                {notices.map((notice, i) => (
                    <Notification
                        key={`notice-${i}`}
                        show={i === displayedIdx}
                        notice={notice}
                        onClose={() => closeNotice(i)}
                    />
                ))}
            </div>
        </div>
    );
};

export default NotificationsBooth;
